<div class="container px-0 pt-5 mt-md-3">
  <div class="row mt-3">
    <div [innerHTML]="translationPrefix + '.content.blueButton' | translate: blueButton" class="col-12"></div>
  </div>

  <div class="row mt-4 justify-content-center">
    <div class="col-xs-12 col-sm-6 col-md-4">
      <button (click)="blueButtonClick()" class="btn btn-info btn-lg btn-block" type="button">
        {{ 'common.buttonLabels.blueButton' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div [innerHTML]="translationPrefix + '.content.blueButtonDisclaimer' | translate: blueButton" class="col-12"></div>
  </div>
</div>
